
import { defineComponent } from "vue";

export default defineComponent({
  name: "ErrorFromHelloasso",
  props: {
    helloassoCheckoutIntentUrl: {
      type: String,
      require: true,
    },
    amount: {
      type: Number,
      require: true,
    },
  },
  methods: {
    centimesToEuro(centimes: number | undefined) {
      if (!centimes) return 0;
      return centimes / 100;
    },
  },
});
